import { useState, useRef, useEffect } from "react";
import { Globe, ChevronDown, Check } from "lucide-react";
import { useLang } from "./LanguageContext";
import { translations, LANG_ORDER } from "./i18n";

export const LanguageSwitcher = ({ full = false }) => {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const names = translations[lang].langNames;
  const order = [lang, ...LANG_ORDER.filter((l) => l !== lang)];

  return (
    <div className={`relative ${full ? "w-full" : ""}`} ref={ref}>
      <button
        data-testid="language-switcher"
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-2 text-xs font-semibold tracking-[0.15em] text-slate-300 hover:text-[#00F2FE] transition-colors ${full ? "w-full justify-between py-2" : ""}`}
      >
        <span className="flex items-center gap-2"><Globe size={15} /> {names[lang]}</span>
        <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          data-testid="language-menu"
          className={`${full ? "relative mt-2" : "absolute right-0 mt-3 min-w-[160px]"} glass border border-[#00F2FE]/25 rounded-sm py-2 z-50`}
        >
          {order.map((code) => (
            <button
              key={code}
              data-testid={`language-option-${code}`}
              onClick={() => { setLang(code); setOpen(false); }}
              className={`w-full flex items-center justify-between px-4 py-2 text-xs tracking-[0.1em] transition-colors ${
                code === lang ? "text-[#00F2FE]" : "text-slate-300 hover:text-white hover:bg-white/5"
              }`}
            >
              {names[code]}
              {code === lang && <Check size={13} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
